import { render, staticRenderFns } from "./OrderExport.vue?vue&type=template&id=06400768&"
import script from "./OrderExport.vue?vue&type=script&lang=js&"
export * from "./OrderExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports